// analisis-periodos.component.ts
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ex } from '@fullcalendar/core/internal-common';
import { id } from '@swimlane/ngx-datatable';
import { parseJSON } from 'jquery';
import { CdkTableVirtualScrollDataSource } from 'ng-table-virtual-scroll';
import { Subscription } from 'rxjs';
import { InterfaceformdataRastreador, RastreadorService } from 'src/app/services/rastreador.service';

export interface AnalisisPeriodos {
  contadorAnalizados: number;
  PAnalizados: number;
  PRangosVolatilidad: number;
  periodosrangoMayor: number;
  periodosRangoMenor: number;
  periodosRangoMayorFin: number;
  periodosRangoMenorFin: number;
  fechaInicio: string,
  fechaFin: string,
  idNectum: number,
  compania: string,
  valorFinFI: number;
  valorFinFF: number;
  valorVolatilidadFI: number;
  valorVolatilidadFF: number;
  valorPorFinal: number;
  fechaVariacionMayor: string;
  fechaVariacionMenor: string;
  variacionMayor: number;
  variacionMenor: number;
  valorFinFechaVariacionMayor: number;
  valorFinFechaVariacionMenor: number;
  existeVolatilidad: boolean;
  vHistoricoI: number;
  vHistoricoF: number;
  vHistorico: number;
  vRelativa: number;
  vRelativaI: number;
  vRelativaF: number;
desviacionStandard: number;
desviacionStandardI: number;
  desviacionStandardF: number;
}

@Component({
  selector: 'app-analisis-periodos',
  templateUrl: './analisis-periodos.component.html',
  styleUrls: ['./analisis-periodos.component.scss']
})
export class AnalisisPeriodosComponent implements OnInit {
  @Input() selectedTab: number = 0;
  /** Emite cuando el usuario pulsa el icono para saltar a la pestaña "Gráfica Análisis". */
  @Output() irAGrafica = new EventEmitter<AnalisisPeriodos>();
  public arrayresultados: Subscription;
  private subCompania: Subscription;
  private subHistoricoCompania: Subscription;
  public companiaSeleccionada: any=null;
  //public Modelformdata: InterfaceformdataRastreador;

  displayedColumns: string[] = ['CAnalizados',
    'periodosrangoMayor',
    'periodosRangoMenor'
  ];//'PRangosVolatilidad', ,'valores',,    'periodosRangoMayorFin',    'periodosRangoMenorFin'

  dataSource: AnalisisPeriodos[] = [];
  dataSource1Activo: AnalisisPeriodos[] = [];
  dataSourceTemp: AnalisisPeriodos[] = [];

  constructor(public _rastreadorSV: RastreadorService) { }

  ngOnInit(): void {
    this.loadData();

     this.arrayresultados = this._rastreadorSV.vallistaResultados$.subscribe({
      next: (data: any)=>{
       //console.log(data);
      const parsedData = typeof data === 'string' ? JSON.parse(data) : data;

      if (parsedData && parsedData.length > 0)
       this.dataSource = parsedData.map((item: any) => ({
          PAnalizados: item.PAnalizados,
          PRangosVolatilidad: item.PRangosVolatilidad,
          periodosrangoMayor: item.PRangoMayor,
          periodosRangoMenor: item.PRangoMenor,
          periodosRangoMayorFin: item.PRangoMayorFin,
          periodosRangoMenorFin: item.PRangoMenorFin,
          fechaInicio: item.fechaInicio,
          fechaFin: item.fechaFin,
          contadorAnalizados : item.contadorAnalizados,
          valorFinFI: item.valorFinFI,
          valorFinFF: item.valorFinFF,
          valorVolatilidadFI: item.valorVolatilidadFI,
          valorVolatilidadFF: item.valorVolatilidadFF,
          fechaVariacionMayor: item.fechaVariacionMayor,
          fechaVariacionMenor: item.fechaVariacionMenor,
          variacionMayor: item.variacionMayor,
          variacionMenor: item.variacionMenor,
          valorFinFechaVariacionMayor: item.valorFinFechaVariacionMayor,
          valorFinFechaVariacionMenor: item.valorFinFechaVariacionMenor,
          idNectum: item.idNectum,
          compania: item.compania,
          existeVolatilidad: item.existeVolatilidad,
        }));
        console.log("DataSource: ", this.companiaSeleccionada);
        console.log("DataSource: ", this.dataSource);
        if(this.companiaSeleccionada != null && this.companiaSeleccionada.idNectum > 0){
          this.dataSource1Activo = this.dataSource.filter(item => item.idNectum === this.companiaSeleccionada.idNectum);
        }
      }
    });
    

    this.subCompania = this._rastreadorSV.valCompaniaSelec$.subscribe({
      next: (data: any)=>{
        console.log("Compania seleccionada: ", data);
        this.companiaSeleccionada=data;
          if(this.companiaSeleccionada != null && this.dataSource.length > 0){
            this.dataSource1Activo = this.dataSource.filter(item => item.idNectum === this.companiaSeleccionada.idNectum);
           
          } else {
            this.dataSource1Activo = [];
          }
        
      }
    });

    
    this.subHistoricoCompania = this._rastreadorSV.valcompaniaVolatividad$.subscribe({
      next: (data: any)=>{
        let combineData = this.flattenArray(data);
        console.log(combineData);
        console.log("Compania seleccionada: ", this.companiaSeleccionada);
        console.log("datasource", this.dataSource1Activo);
       //let datos = this.dataSource.filter(item => item.idNectum === this.companiaSeleccionada.idNectum);
        //console.log("Datos filtrados: ", this.dataSource1Activo);
         this.dataSource1Activo.forEach(item => {
          // item.fechaInicio es un string en formato 'DD/MM/YYYY'
       // const fechaInicioDate =item.fechaInicio;
       // const fechaFinDate = item.fechaFin;
        const fechaInicio = item.fechaInicio.split('/');
        const fechaFin = item.fechaFin.split('/');
        const fechainiciostring:string = `${fechaInicio[2]}-${fechaInicio[1]}-${fechaInicio[0]}`;
        const fechafinstring:string = `${fechaFin[2]}-${fechaFin[1]}-${fechaFin[0]}`;

        //console.log("fechaInicioDate: ", fechaInicioDate + " fechaFinDate: ", fechaFinDate);
       // buscar el objeto en combineData que coincida con las fechas 
       console.log("fechainiciostring: ", fechainiciostring + " fechafinstring: ", fechafinstring);
       
        const periodData = combineData.filter(item => String(item.date) === fechainiciostring );
        const periodDataFin = combineData.filter(item => String(item.date) === fechafinstring );
        console.log("periodData: ", periodData);
        console.log("periodDataFin: ", periodDataFin);
          if(periodData.length == 1 && periodDataFin.length == 1){
                  item.vHistoricoI = periodData[0].condicion2;;
                  item.vHistoricoF = periodDataFin[0].condicion2;
                  item.vHistorico = (( periodDataFin[0].condicion2 - periodData[0].condicion2 ) / periodData[0].condicion2) * 100;
                  item.vRelativaI = periodData[0].condicion3;
                  item.vRelativaF = periodDataFin[0].condicion3;
                  item.vRelativa = (( periodDataFin[0].condicion3 - periodData[0].condicion3 ) / periodData[0].condicion3) * 100;
                  item.desviacionStandardI = periodData[0].condicion4;
                  item.desviacionStandardF = periodDataFin[0].condicion4;
                  item.desviacionStandard = (( periodDataFin[0].condicion4 - periodData[0].condicion4 ) / periodData[0].condicion4) * 100;
                  console.log("item actualizado: ", item);
          }
        });
        //this.histVolCompData = new CdkTableVirtualScrollDataSource(combineData);
        //this.actualizarViewport();
        // Publica el resultado enriquecido (con volatilidad ya calculada) para que otros
        // componentes (ej. GraficaModeloComponent, leyenda de período por hover) no dupliquen este cálculo.
        this._rastreadorSV.updatePeriodosEnriquecidos(this.dataSource1Activo);
      }
    });
  }

  /** Click en el icono de la fila: salta a la pestaña "Gráfica Análisis" y hace zoom al período. */
  verEnGrafica(row: AnalisisPeriodos): void {
    const inicioMs = this.aMs(row.fechaInicio);
    const finMs = this.aMs(row.fechaFin);
    if (inicioMs !== null && finMs !== null) {
      this._rastreadorSV.enfocarPeriodo(inicioMs, finMs);
    }
    this.irAGrafica.emit(row);
  }

  /** 'DD/MM/YYYY' -> ms */
  private aMs(fecha: string): number | null {
    if (!fecha) return null;
    const p = fecha.split('/');
    if (p.length !== 3) return null;
    const ms = new Date(`${p[2]}-${p[1]}-${p[0]}`).getTime();
    return Number.isFinite(ms) ? ms : null;
  }

  private convertToDate(dateString: string): Date {
    // Asumiendo formato DD/MM/YYYY
    if (dateString.includes('/')) {
      const parts = dateString.split('/');
      // new Date(year, month-1, day) - el mes es 0-indexado
      return new Date(parseInt(parts[2]), parseInt(parts[1]) - 1, parseInt(parts[0]));
    }
    
    // Si el formato es diferente, ajustar según sea necesario
    // Por ejemplo, para formato YYYY-MM-DD:
    if (dateString.includes('-')) {
      return new Date(dateString);
    }
    
    // Fallback: intentar parsear directamente
    return new Date(dateString);
  }

flattenArray(arrayOfArrays: any[]): any[] {

    return arrayOfArrays.flatMap(innerArray => innerArray);
  }


  loadData() {
    // Aquí cargarías los datos desde tu servicio
    // this.dataSource = this.rastreadorService.getAnalisisPeriodos();
  }
}